@if (showBanner()) {
  <section class="dynamic-banner" (mouseenter)="pauseMarquee()" (mouseleave)="resumeMarquee()">
    <div class="row">
      <div class="flipping-text-header">
        <span class="marquee-inner" [innerHTML]="bannerHeader()"></span>
      </div>
      <div class="flipping-text">
        <span class="marquee-inner" [innerHTML]="bannerText()"></span>
      </div>
    </div>
  </section>
}

<div class="container-fluid banner-page-container">
  <h3>Banner Update</h3>

  @if (showSuccess()) {
    <div class="popup-message success">Banner updated successfully!</div>
  }

  @if (showError()) {
    <div class="popup-message error">Error updating banner. Please try again.</div>
  }

  <div class="header-row">
    <p-editor
      [(ngModel)]="bannerHeader"
      class="banner-header-editor"
      [modules]="headerEditorModules"
      placeholder="Banner header (optional)"
    />

    <div class="shutoff-time-container">
      <label class="shutoff-time-label">Banner Shutoff Time (optional)</label>
      <div class="datetime-inputs">
        <div class="date-time-row">
          <input
            type="date"
            [(ngModel)]="shutoffDate"
            class="shutoff-date-input"
            placeholder="Select date"
          />
          <input
            type="time"
            [(ngModel)]="shutoffTime"
            class="shutoff-time-input"
            placeholder="Select time"
          />
        </div>
        <button
          type="button"
          class="clear-datetime-button"
          (click)="clearDateTime()"
          [disabled]="!shutoffDate() && !shutoffTime()"
        >
          Clear
        </button>
      </div>
    </div>
  </div>

  <p-editor
    [(ngModel)]="bannerText"
    class="banner-body-editor"
    [modules]="bodyEditorModules"
    placeholder="Enter your banner text message here..."
  />

  <div class="button-container">
    <invd-button (click)="viewCurrentBanner()" class="current-banner-button"
      >View Current Banner</invd-button
    >

    <invd-button class="preview-button" (click)="preview()" [disabled]="isFormEmpty()"
      >Preview</invd-button
    >

    <invd-button (click)="onSubmit()" [disabled]="isFormEmpty()">Submit Update</invd-button>
  </div>
</div>
